module.exports = __webpack_public_path__ + "img/全国销售毛利率.9e745cf7.png";